import React, { useState, useEffect } from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import alphabet from "../../Assets/Images/alphabet.png";
import amazon from "../../Assets/Images/Amazon.png";
import cisco from "../../Assets/Images/cisco.png";
import microsoft from "../../Assets/Images/microsoft.png";
import intel from "../../Assets/Images/intel.png";
import wix from "../../Assets/Images/wix.png";
import Header from "../../components/common/Header";
import axios from "axios";
import { Loader2, CheckCircle, XCircle } from "lucide-react";
import Swal from "sweetalert2";

const API_URL = process.env.REACT_APP_API_URL;

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    course: "",
    message: "",
  });

  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("idle");

  // Fetch courses from backend
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_URL}/courses/get-all`);
        if (response.data.success) {
          setCourses(response?.data?.data);
        }
      } catch (err) {
        console.error("Error fetching courses:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      // Only allow digits and limit to 10 characters
      const numericValue = value.replace(/\D/g, "");
      if (numericValue.length <= 10) {
        setFormData({ ...formData, [name]: numericValue });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setStatus("loading");

  //   try {
  //     const response = await axios.post(`${API_URL}/contact/create`, formData);

  //     if (response.data.success) {
  //       setStatus("success");

  //       // Show SweetAlert with custom message
  //       Swal.fire({
  //        icon: "success",
  //         title: "Enquiry Sent Successfully!",
  //       text:"We will get back to you soon",
  //         confirmButtonText: "OK",
  //         confirmButtonColor: "#DA3335",
  //         customClass: {
  //           popup: "rounded-2xl",
  //           confirmButton: "rounded-lg px-6 py-2",
  //         },
  //       });

  //       // Reset form
  //       setFormData({
  //         name: "",
  //         email: "",
  //         phone: "",
  //         course: "",
  //         centre: "",
  //         message: "",
  //       });

  //       setTimeout(() => setStatus("idle"), 2000);
  //     }
  //   } catch (err) {
  //     console.error("Error submitting form:", err);
  //     setStatus("error");

  //     // Show error SweetAlert
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text:
  //         err.response?.data?.message ||
  //         "Failed to send Enquiry. Please try again.",
  //       confirmButtonText: "Try Again",
  //       confirmButtonColor: "#DA3335",
  //       customClass: {
  //         popup: "rounded-2xl",
  //         confirmButton: "rounded-lg px-6 py-2",
  //       },
  //     });

  //     setTimeout(() => setStatus("idle"), 2000);
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate phone number
    if (!formData.phone || formData.phone.length !== 10) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Phone Number",
        text: "Please enter a valid 10-digit phone number before submitting.",
        confirmButtonColor: "#DA3335",
      });
      return;
    }

    setStatus("loading");

    try {
      const response = await axios.post(`${API_URL}/contact/create`, formData);

      if (response.data.success) {
        setStatus("success");
        Swal.fire({
          icon: "success",
          title: "Enquiry Sent Successfully!",
          text: "We will get back to you soon.",
          confirmButtonText: "OK",
          confirmButtonColor: "#DA3335",
        });

        // Reset form
        setFormData({
          name: "",
          email: "",
          phone: "",
          course: "",
          message: "",
        });
        setTimeout(() => setStatus("idle"), 2000);
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      setStatus("error");
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          err.response?.data?.message ||
          "Failed to send Enquiry. Please try again.",
        confirmButtonColor: "#DA3335",
      });
      setTimeout(() => setStatus("idle"), 2000);
    }
  };

  return (
    <>
      <Header
        breadcrumbs={[
          { label: "HOME", path: "/" },
          { label: "CONTACT", path: "/contact" },
        ]}
        title="Contacts"
        description=" We’re here to help you every step of the way. Whether you have questions about courses, enrollment, or technical support, our team is ready to assist you. You can reach out to us through email, phone, or live chat for quick and friendly support. Stay connected with us to get updates on new courses, events, and learning opportunities."
      />

      <div className="tracking-wide px-4 sm:px-6 lg:px-8 py-10 flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-20">
        <div className="flex-[0.9] space-y-8 text-center lg:text-left">
          <h1 className="font-bold text-3xl sm:text-4xl md:text-5xl heading">
            Contact Us
          </h1>
          <p className="text-gray-600 text-base sm:text-lg md:text-xl leading-relaxed sub-heading">
            Have questions or need support? We’re here to help! Reach out to our
            team anytime through email.
          </p>

          <div className="space-y-8">
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-5">
              <div className="bg-black rounded-xl">
                <div className="bg-[#DA3335] p-4 rounded-xl -translate-x-1 -translate-y-1 flex items-center justify-center">
                  <Phone size={28} className="text-white" />
                </div>
              </div>
              <div>
                <h3 className="font-bold text-lg heading">Call Us</h3>
                <p className="text-gray-700 text-sm sm:text-base sub-heading">
                  7205648333
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-5">
              <div className="bg-black rounded-xl">
                <div className="bg-[#DA3335] p-4 rounded-xl -translate-x-1 -translate-y-1 flex items-center justify-center">
                  <Mail size={28} className="text-white" />
                </div>
              </div>
              <div>
                <h3 className="font-bold text-lg heading">Email Address</h3>
                <p className="text-gray-700 text-sm sm:text-base sub-heading">
                  info@insdbhubaneswar.com
                </p>
                {/* <p className="text-gray-700 text-sm sm:text-base sub-heading">
                  collab-support@example.com
                </p> */}
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-5">
              <div className="bg-black rounded-xl">
                <div className="bg-[#DA3335] p-4 rounded-xl -translate-x-1 -translate-y-1 flex items-center justify-center">
                  <MapPin size={28} className="text-white" />
                </div>
              </div>
              <div>
                <h3 className="font-bold text-lg heading">Reach Us</h3>
                <p className="text-gray-700 text-sm sm:text-base sub-heading">
                  3rd Floor, C/o-Hdfc bank, Biju Pattnaik College Rd,
                </p>
                <p className="text-gray-700 text-sm sm:text-base sub-heading">
                  Jayadev Vihar, Bhubaneswar, Odisha 751013
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex-[1.2] w-full rounded-2xl overflow-hidden shadow-md ">
          {/* <iframe
            title="map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d119743.41347163479!2d85.7378806060619!3d20.30102579356921!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a1909d2d5170aa5%3A0xfc580e2b68b33fa8!2sBhubaneswar%2C%20Odisha!5e0!3m2!1sen!2sin!4v1759897806020!5m2!1sen!2sin"
            className="w-full h-64 sm:h-80 md:h-[400px] lg:h-[550px] rounded-xl"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe> */}
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3742.0542554494136!2d85.81193657523686!3d20.29802128117472!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjDCsDE3JzUyLjkiTiA4NcKwNDgnNTIuMiJF!5e0!3m2!1sen!2sin!4v1761327586765!5m2!1sen!2sin"
            className="w-full h-64 sm:h-80 md:h-[400px] lg:h-[550px] rounded-xl"
            allowFullScreen
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

      <div className="tracking-wide min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center p-4 sm:p-6 md:p-10 relative overflow-hidden">
        <div className="absolute w-24 h-24 sm:w-32 sm:h-32 bg-[#DA3335] rounded-2xl opacity-80 rotate-45 top-[-60px] left-[-60px]" />
        <div className="absolute w-16 h-16 sm:w-20 sm:h-20 bg-[#DA3335] rounded-2xl opacity-80 rotate-45 top-[40%] left-[5%]" />
        <div className="absolute w-20 h-20 sm:w-24 sm:h-24 bg-[#DA3335] rounded-2xl opacity-80 rotate-45 top-[20%] right-[10%]" />
        <div className="absolute w-40 h-40 sm:w-52 sm:h-52 bg-[#DA3335] rounded-2xl opacity-80 rotate-45 bottom-[-100px] right-[-100px]" />

        <div className="relative z-10 w-full max-w-4xl bg-white/60 backdrop-blur-md rounded-3xl shadow-xl p-6 sm:p-8 md:p-12">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-gray-800 mb-10 leading-tight heading">
            Contact Our Support Team to <br /> Know What You Want
          </h1>

          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-2 heading">
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your Name"
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:outline-none focus:border-yellow-300 focus:ring-2 focus:ring-yellow-100 transition-all"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-2 heading">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your Email"
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:outline-none focus:border-yellow-300 focus:ring-2 focus:ring-yellow-100 transition-all"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-2 heading">
                  Phone
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  maxLength={10}
                  inputMode="numeric"
                  pattern="[0-9]*"
                  placeholder="Your 10-digit Phone"
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:outline-none focus:border-yellow-300 focus:ring-2 focus:ring-yellow-100 transition-all"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-2 heading">
                  Course
                </label>
                <select
                  name="course"
                  value={formData.course}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl bg-white focus:outline-none focus:border-yellow-300 focus:ring-2 focus:ring-yellow-100 transition-all"
                  required
                  disabled={loading}
                >
                  <option value="">
                    {loading ? "Loading courses..." : "Choose a Course"}
                  </option>
                  {courses.map((course) => (
                    <option key={course._id} value={course._id}>
                      {/* {course.name} */}
                      {course.category}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="mb-8">
              <label className="block text-sm font-semibold text-gray-800 mb-2 heading">
                Message
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Type Your Message"
                rows="6"
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl resize-none focus:outline-none focus:border-yellow-300 focus:ring-2 focus:ring-yellow-100 transition-all"
                required
              />
            </div>

            <button
              type="submit"
              disabled={status === "loading"}
              className={`w-full flex items-center justify-center gap-2 font-bold rounded-xl py-4 transition-all overflow-hidden text-white 
          ${
            status === "success"
              ? "bg-green-500"
              : status === "error"
                ? "bg-red-500"
                : "bg-gradient-to-r from-primaryColor to-secondaryColor hover:opacity-90"
          }`}
            >
              {status === "loading" && (
                <Loader2 className="animate-spin h-5 w-5 text-white" />
              )}
              {status === "success" && (
                <CheckCircle className="h-5 w-5 text-white animate-bounce" />
              )}
              {status === "error" && (
                <XCircle className="h-5 w-5 text-white animate-pulse" />
              )}
              <span>
                {status === "loading"
                  ? "Sending..."
                  : status === "success"
                    ? "Sent!"
                    : status === "error"
                      ? "Failed!"
                      : "Send Your Message"}
              </span>
            </button>
          </form>
        </div>
      </div>

      {/* <div className="tracking-wide py-10 px-4 sm:px-6 lg:px-8 flex flex-col items-center space-y-16">
        <h1 className="font-bold font-barlow text-4xl sm:text-3xl md:text-5xl text-center leading-snug xl:w-[52%] w-full  p-4 ">
          Employees of These Companies Study With Us
        </h1>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-6 sm:gap-8">
          {[microsoft, intel, alphabet, wix, cisco, amazon].map((logo, i) => (
            <div key={i} className="flex justify-center">
              <img
                src={logo}
                alt="company logo"
                className="h-8 sm:h-10 w-auto object-contain"
              />
            </div>
          ))}
        </div>
      </div> */}
    </>
  );
};

export default Contact;
